import '../Core/scripts/sitewide';
import '../Core/scss/_footer.scss';
import './style.scss';

import {smoothScroll} from '../Core/scripts/utilities';
window.smoothScroll = smoothScroll;